import Logger from '@/lib/logger'
import Cookie from 'js-cookie'

export default function() {
  const referrer = Cookie.get('logoReferrer')

  // Set the referrer for a max of 1 day before expiring
  if (!referrer) {
    Logger.debug('Setting referrer')
    Cookie.set('logoReferrer', document.referrer, {
      expires: 1,
    })
  }
}
